import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import "react";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import MUIMenuItem from "../../../material/MenuItem/MenuItem.es.js";
const _excluded = ["native"];
function MUISelectOption(_ref) {
  let {
    native
  } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (native) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("option", _extends({}, props));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MUIMenuItem, _extends({}, props));
}
export {
  MUISelectOption as default
};
//# sourceMappingURL=MUISelectOption.es.js.map
